import { SlaTableWrap, SlaName, SlaValue, SlaDisclaimer, AdditionalInfoCell } from './styles';
import { Link } from '../../styles';
import { Button, ButtonTypes } from '@common/components';
import DashboardSection from '../WidgetBase/DashboardSection';
import { ISlaWidget, DisplayMode } from './types';
import { WidgetData } from '../../types';
import { useFeatureFlags } from '@common/hooks/useFeatureFlags';

const SlaWidget = (widgetData: WidgetData) => {
  const { activeSla, generalItems, christmasItems, subHeading, contentPolicyLink, description } = widgetData.data as ISlaWidget;
  const { showUpdatedContentPolicy } = useFeatureFlags();
  const hasDeadlines = activeSla === DisplayMode.Christmas;
  const slaItems = hasDeadlines ? christmasItems : generalItems;

  const contentPolicyLinkValue = contentPolicyLink ?
    (!showUpdatedContentPolicy ?
       contentPolicyLink.replace(/contentPolicy\.pdf/i, 'contentPolicy.v.1.15.pdf') :
      contentPolicyLink
    ) :
    null;

  const toFormatedString = (date: Date) => {
    return new Date(date).toLocaleDateString('en-GB',);
  }

  return (
    <DashboardSection>
      <SlaTableWrap>
        <h2>SLA Information</h2>
        <table>
          <tbody>
            {hasDeadlines && (
              <tr>
                <AdditionalInfoCell>
                  <h3>
                    {subHeading && (subHeading)}
                  </h3>
                </AdditionalInfoCell>
                <td />
                <td colSpan={2}>
                  <h3>Submission deadline</h3>
                </td>
              </tr>
            )}
            {hasDeadlines && (
              <tr>
                <td />
                <td />
                <SlaValue>Christmas</SlaValue>
                <SlaValue>New Year</SlaValue>
              </tr>
            )}
            {slaItems?.map(({ name, value, christmasDeadline, newYearDeadline }) => (
              <tr key={name}>
                <SlaName>{name}</SlaName>
                <SlaValue>{value}</SlaValue>
                {hasDeadlines && (
                  <>
                    <SlaValue>{christmasDeadline ? toFormatedString(christmasDeadline) : 'N/A'}</SlaValue>
                    <SlaValue>{newYearDeadline ? toFormatedString(newYearDeadline) : 'N/A'}</SlaValue>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </SlaTableWrap>
      <SlaDisclaimer>
        {description && (description)}{' '}
        <Link
          target="_blank"
          href="https://s3.eu-west-2.amazonaws.com/datapharm/dms/documents/Guide_to_MHRA_10_Day_Calculation.pdf"
        >
          learn more
        </Link>
      </SlaDisclaimer>
      <Button
        type={ButtonTypes.PRIMARY_MEDIUM_BORDER}
        height={50}
        width={210}
        text="View Content Policy"
       onClick={() => contentPolicyLinkValue && window.open(contentPolicyLinkValue)}
      />
    </DashboardSection>
  );
};

export default SlaWidget;
